import Web3 from 'web3'
import { useLayoutStore, useWalletStore } from '@/store'

export async function connectWallet() {
  const walletStore = useWalletStore()
  const layoutStore = useLayoutStore()

  layoutStore.startLoading()

  try {
    const web3 = new Web3()

    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
    web3.setProvider(window.ethereum)

    walletStore.address = accounts[0]
    walletStore.web3 = web3

    window.ethereum.on('disconnect', () => window.location.reload())
    window.ethereum.on('accountsChanged', () => window.location.reload())
    window.ethereum.on('chainChanged', () => window.location.reload())
  } catch (e) {
    layoutStore.stopLoading()
  }

  layoutStore.stopLoading()
}